import { Backdrop, Box, Grid, Typography } from "@mui/material";
import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PrimaryButon from "../../components/customButtons/PrimaryButon";
import PrimarySmallBlueButton from "../../components/customButtons/PrimarySmallBlueButton";
import BlueCancelButton from "../../components/customButtons/BlueCancelButton";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import Loader from "../../../SAPPages/components/Loader/Loader";
export default function DemoConfimationScreen({
  handleClose,
  formData,
  handleSubmitData,
  submitLoading,
}) {



  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {submitLoading && (
          <Backdrop open={submitLoading} style={{ zIndex: 9999 }}>
            <Loader text="Submiiting Data..." />
          </Backdrop>
        )}
      </Grid>
      <Grid item xs={12}>
        <Box display="flex" alignItems="center" gap={1}>
          <InfoOutlinedIcon style={{ color: "#FAAE2D" }} />
          <Typography
            textAlign="start"
            color="#000000"
            fontFamily="Inter"
            fontSize="16px"
            lineHeight="20px"
            letterSpacing="0.1px"
            style={{ fontWeight: 400 }}
          >
            {" "}
            Please review your details before confirmation
          </Typography>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box
          sx={{
            borderRadius: 3,
            background: "#F9F9F966",
            border: "1px solid #EEEEEE",
            p: 2,
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Box display="flex" alignItems="center" gap={1}>
                <Box width={30} height={30}>
                  <img src="/newdashboard/Demo/Group 1171283409 (7).png" />
                </Box>
                <Typography
                  color="#000000"
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="100%"
                  letterSpacing="0%"
                  style={{ fontWeight: 400 }}
                >
                  Test type :{" "}
                  <span
                    style={{
                      color: "#9D0385",
                      fontWeight: 600,
                      fontFamily: "Inter",
                    }}
                  >
                    {formData?.test_type_name}
                  </span>
                </Typography>
              </Box>
            </Grid>

            {formData?.sub_test_type_id && (
              <Grid item xs={12} sm={6}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box width={30} height={30}>
                    <img src="/newdashboard/Demo/Group 1171283409 (7).png" />
                  </Box>
                  <Typography
                    color="#000000"
                    fontFamily="Inter"
                    fontSize="14px"
                    lineHeight="100%"
                    letterSpacing="0%"
                    style={{ fontWeight: 400 }}
                  >
                    Sub Test type :{" "}
                    <span
                      style={{
                        color: "#9D0385",
                        fontWeight: 600,
                        fontFamily: "Inter",
                      }}
                    >
                      {formData?.sub_test_type_id?.name}
                    </span>
                  </Typography>
                </Box>
              </Grid>
            )}

            {formData?.test_delivery_format && (
              <Grid item xs={12} sm={6}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box width={30} height={30}>
                    <img src="/newdashboard/Demo/Group 1171283409 (7).png" />
                  </Box>
                  <Typography
                    color="#000000"
                    fontFamily="Inter"
                    fontSize="14px"
                    lineHeight="100%"
                    letterSpacing="0%"
                    style={{ fontWeight: 400 }}
                  >
                    Test Delivery Format :{" "}
                    <span
                      style={{
                        color: "#9D0385",
                        fontWeight: 600,
                        fontFamily: "Inter",
                      }}
                    >
                      {formData?.test_delivery_format?.name}
                    </span>
                  </Typography>
                </Box>
              </Grid>
            )}
            <Grid item xs={12} sm={6}>
              <Box display="flex" alignItems="center" gap={1}>
                <Box width={30} height={30}>
                  <img src="/newdashboard/Demo/Group 1171283409 (1).png" />
                </Box>
                <Typography
                  color="#000000"
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="100%"
                  letterSpacing="0%"
                  style={{ fontWeight: 400 }}
                >
                  Delivery Mode :{" "}
                  <span
                    style={{
                      color: "#9D0385",
                      fontWeight: 600,
                      fontFamily: "Inter",
                    }}
                  >
                    {formData?.delivery_mode_name}
                  </span>
                </Typography>
              </Box>
            </Grid>

            {/* {formData?.branch_id && (
              <Grid item xs={12} sm={6}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box width={30} height={30}>
                    <img src="/newdashboard/Demo/Group 1171283409 (7).png" />
                  </Box>
                  <Typography
                    color="#000000"
                    fontFamily="Inter"
                    fontSize="14px"
                    lineHeight="100%"
                    letterSpacing="0%"
                    style={{ fontWeight: 400 }}
                  >
                    Branch :{" "}
                    <span
                      style={{
                        color: "#9D0385",
                        fontWeight: 600,
                        fontFamily: "Inter",
                      }}
                    >
                      {formData?.branch_id?.branch_name}
                    </span>
                  </Typography>
                </Box>
              </Grid>
            )} */}

            <Grid item xs={12} sm={6}>
              <Box display="flex" alignItems="center" gap={1}>
                <Box width={30} height={30}>
                  <img src="/newdashboard/Demo/Group 1171283409 (2).png" />
                </Box>
                <Typography
                  color="#000000"
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="100%"
                  letterSpacing="0%"
                  style={{ fontWeight: 400 }}
                >
                  Demo Date :{" "}
                  <span
                    style={{
                      color: "#9D0385",
                      fontWeight: 600,
                      fontFamily: "Inter",
                    }}
                  >
                    {formData?.available_demo_date}
                  </span>
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Box display="flex" alignItems="center" gap={1}>
                <Box width={30} height={30}>
                  <img src="/newdashboard/Demo/Group 1171283409 (3).png" />
                </Box>
                <Typography
                  color="#000000"
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="100%"
                  letterSpacing="0%"
                  style={{ fontWeight: 400 }}
                >
                  Exam taken Before :{" "}
                  <span
                    style={{
                      color: "#9D0385",
                      fontWeight: 600,
                      fontFamily: "Inter",
                    }}
                  >
                    {formData?.exam_already_given}
                  </span>
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Box display="flex" alignItems="center" gap={1}>
                <Box width={30} height={30}>
                  <img src="/newdashboard/Demo/Group 1171283409 (7).png" />
                </Box>
                <Typography
                  color="#000000"
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="100%"
                  letterSpacing="0%"
                  style={{ fontWeight: 400 }}
                >
                  {formData?.exam_already_given === "Yes"
                    ? "Overall Band Score"
                    : "Target Band Score"}{" "}
                  :{" "}
                  <span
                    style={{
                      color: "#9D0385",
                      fontWeight: 600,
                      fontFamily: "Inter",
                    }}
                  >
                    {formData?.score}
                  </span>
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Box display="flex" alignItems="center" gap={1}>
                <Box width={30} height={30}>
                  <img src="/newdashboard/Demo/Group 1171283409 (4).png" />
                </Box>
                <Typography
                  color="#000000"
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="100%"
                  letterSpacing="0%"
                  style={{ fontWeight: 400 }}
                >
                  Booked Exam :{" "}
                  <span
                    style={{
                      color: "#9D0385",
                      fontWeight: 600,
                      fontFamily: "Inter",
                    }}
                  >
                    {formData?.is_exam_booked}
                  </span>
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Box display="flex" alignItems="center" gap={1}>
                <Box width={30} height={30}>
                  <img src="/newdashboard/Demo/Group 1171283409 (2).png" />
                </Box>
                <Typography
                  color="#000000"
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="100%"
                  letterSpacing="0%"
                  style={{ fontWeight: 400 }}
                >
                  {formData?.is_exam_booked === "Yes"
                    ? "Exam Date"
                    : "Tentative Exam Date"}{" "}
                  :{" "}
                  <span
                    style={{
                      color: "#9D0385",
                      fontWeight: 600,
                      fontFamily: "Inter",
                    }}
                  >
                    {formData?.tentative_date}
                  </span>
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Box display="flex" alignItems="center" gap={1}>
                <Box width={30} height={30}>
                  <img src="/newdashboard/Demo/Group 1171283409 (8).png" />
                </Box>
                <Typography
                  color="#000000"
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="100%"
                  letterSpacing="0%"
                  style={{ fontWeight: 400 }}
                >
                  Preparation :{" "}
                  <span
                    style={{
                      color: "#9D0385",
                      fontWeight: 600,
                      fontFamily: "Inter",
                    }}
                  >
                    {formData?.preparation}
                  </span>
                </Typography>
              </Box>
            </Grid>

            {formData?.institute_name && (
              <Grid item xs={12} sm={6}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box width={30} height={30}>
                    <img src="/newdashboard/Demo/Group 1171283409 (7).png" />
                  </Box>
                  <Typography
                    color="#000000"
                    fontFamily="Inter"
                    fontSize="14px"
                    lineHeight="100%"
                    letterSpacing="0%"
                    style={{ fontWeight: 400 }}
                  >
                    Institute Name:{" "}
                    <span
                      style={{
                        color: "#9D0385",
                        fontWeight: 600,
                        fontFamily: "Inter",
                      }}
                    >
                      {formData?.institute_name}
                    </span>
                  </Typography>
                </Box>
              </Grid>
            )}

            <Grid item xs={12} sm={12}>
              <Box display="flex" alignItems="center" gap={1}>
                <Box width={30} height={30}>
                  <img src="/newdashboard/Demo/Group 1171283409 (6).png" />
                </Box>
                <Typography
                  color="#000000"
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="100%"
                  letterSpacing="0%"
                  style={{ fontWeight: 400 }}
                >
                  Session Time :{" "}
                  <span
                    style={{
                      color: "#9D0385",
                      fontWeight: 600,
                      fontFamily: "Inter",
                    }}
                  >
                    {formData?.session_data?.slots} (IST)
                    {formData?.delivery_mode_name === "offline" && (
                      <>
                        <span style={{ margin: "0 8px" }}>|</span>
                        {formData?.branch_id?.branch_name}
                      </>
                    )}
                  </span>
                </Typography>
              </Box>
            </Grid>
          </Grid>{" "}
        </Box>
      </Grid>

      <Grid item xs={12} container gap={2} justifyContent="center">
        <BlueCancelButton
          buttonTitle="Not Yet"
          startIcon={<ClearIcon />}
          onClick={handleClose}
        />
        <PrimarySmallBlueButton
          buttonTitle="Yes, Confirm Booking"
          startIcon={<DoneIcon />}
          onClick={handleSubmitData}
        />
      </Grid>
    </Grid>
  );
}
